import { render, staticRenderFns } from "./VehicleDetails.vue?vue&type=template&id=771a95e5&scoped=true&"
import script from "./VehicleDetails.vue?vue&type=script&lang=js&"
export * from "./VehicleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771a95e5",
  null
  
)

export default component.exports